<div class="cm-skeleton-section">
  <!-- Header with title/subtitle and primary action button -->
  <div class="cm-skeleton-section-header">
    <div class="cm-skeleton-section-header-left">
      <div class="cm-skeleton cm-skeleton--text cm-skeleton--lg cm-skeleton--{{ animation() }}" style="width: 200px;"></div>
      <div class="cm-skeleton cm-skeleton--text cm-skeleton--sm cm-skeleton--{{ animation() }}" style="width: 350px; margin-top: 0.25rem;"></div>
    </div>
    <div class="cm-skeleton cm-skeleton--rectangle cm-skeleton--{{ animation() }}" style="width: 180px; height: 40px; border-radius: 4px;"></div>
  </div>

  <!-- Table structure: Name / Description / Linked type + row actions -->
  <div class="cm-skeleton-section-table">
    <!-- Table header -->
    <div class="cm-skeleton-section-table-header">
      <div class="cm-skeleton cm-skeleton--text cm-skeleton--md cm-skeleton--{{ animation() }}" style="width: 80px;"></div>
      <div class="cm-skeleton cm-skeleton--text cm-skeleton--md cm-skeleton--{{ animation() }}" style="width: 110px;"></div>
      <div class="cm-skeleton cm-skeleton--text cm-skeleton--md cm-skeleton--{{ animation() }}" style="width: 120px;"></div>
      <div class="cm-skeleton cm-skeleton--text cm-skeleton--md cm-skeleton--{{ animation() }}" style="width: 70px;"></div>
    </div>

    <!-- Table rows -->
    @for (item of [].constructor(5); track $index) {
      <div class="cm-skeleton-section-table-row">
        <div class="cm-skeleton-section-table-cell">
          <div class="cm-skeleton cm-skeleton--text cm-skeleton--md cm-skeleton--{{ animation() }}" style="width: 70%;"></div>
        </div>
        <div class="cm-skeleton-section-table-cell">
          <div class="cm-skeleton cm-skeleton--text cm-skeleton--md cm-skeleton--{{ animation() }}" style="width: 90%;"></div>
        </div>
        <div class="cm-skeleton-section-table-cell">
          <div class="cm-skeleton cm-skeleton--text cm-skeleton--md cm-skeleton--{{ animation() }}" style="width: 40%;"></div>
        </div>
        <div class="cm-skeleton-section-table-cell">
          <div style="display: flex; gap: 0.5rem;">
            <div class="cm-skeleton cm-skeleton--rectangle cm-skeleton--{{ animation() }}" style="width: 32px; height: 32px;"></div>
            <div class="cm-skeleton cm-skeleton--rectangle cm-skeleton--{{ animation() }}" style="width: 32px; height: 32px;"></div>
          </div>
        </div>
      </div>
    }
  </div>
</div>
